'use client';

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import AccountDetails, { AccountDetailsProps } from 'components/commercetools-ui/organisms/account';
import useUpdateCartAddresses from 'helpers/hooks/useUpdateCartAddresses';
import { TasticProps } from 'frontastic/tastics/types';
import { useAccount } from 'frontastic/hooks';
import useLocale from 'helpers/hooks/useLocale';
import { DataLayerOnLoad } from 'helpers/dataLayerHelpers';

const AccountDetailsTastic = ({ data }: TasticProps<AccountDetailsProps>) => {
  const updateCartAddresses = useUpdateCartAddresses();
  const [isPushedAccount, setIsPushedAccount] = useState(false);
  const [isPushedSupport, setIsPushedSupport] = useState(false);
  const { account } = useAccount();
  const { getCountry, getCurrency } = useLocale();
  const params = useSearchParams();

  useEffect(() => {
    updateCartAddresses();
  }, [updateCartAddresses]);

  useEffect(() => {
    const supportParams = params.get('hash');
    const isPushedDimension = supportParams === 'support' ? 'support' : 'account';
    const localeData = {
      country: getCountry(),
      currency: getCurrency(),
    };
    const currentUrl = document.location.origin;

    if (!isPushedSupport && isPushedDimension === 'support') {
      const dataLayer = new DataLayerOnLoad(currentUrl, 'support', localeData, account);
      dataLayer.setDataLayerOnLoad();
      setIsPushedSupport(true);
    }

    if (!isPushedAccount && isPushedDimension === 'account') {
      const dataLayer = new DataLayerOnLoad(currentUrl, 'account', localeData, account);
      dataLayer.setDataLayerOnLoad();
      setIsPushedAccount(true);
    }
  }, [params.get, isPushedAccount, isPushedSupport, account]);

  return <AccountDetails {...data} />;
};

export default AccountDetailsTastic;
